import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import ApiSecConfigListing from "./ApiSecConfigListing";
import ApiSecCredentialsForm from "./ApiSecCredentialsForm";

export default function ApiSecPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={ApiSecCredentialsForm}
      PullConfigListingView={ApiSecConfigListing}
    />
  );
}